import FinancialTransactionCountCard from "~/components/Metrics/FinancialTransactionCountsCard";
import api from "~/api";
import { useTranslation } from "react-i18next";

const FinancialTransactionCount = () => {
  const { t } = useTranslation();
  const getFinancialTransactionCountMetrics = async (
    params: MetricsAPI.GetMetricQuery & MetricsAPI.GetFinancialTransactionQuery
  ) => {
    try {
      const { data } = await api.metrics.getFinancialTransactionsByNetwork(params);
      if (data) {
        return data.data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <FinancialTransactionCountCard
      title={`${t("title.financialTransactionCountsBy")} ${t("text.network")}`}
      onUpdate={getFinancialTransactionCountMetrics}
    />
  );
};

export default FinancialTransactionCount;
